export const domain = 'ProductModal';

// action types
export const SHOW_PRODUCT_MODAL = `${domain}/SHOW_PRODUCT_MODAL`;
export const HIDE_PRODUCT_MODAL = `${domain}/HIDE_PRODUCT_MODAL`;
